import type { IntlShape } from "react-intl";

function isSameDay(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

// Time of day; earlier days get a short date in front (month and day, plus
// the year when it is not the current one).
export function formatEventTime(intl: IntlShape, iso: string | null | undefined) {
  if (!iso) return "";
  const date = new Date(iso);
  const now = new Date();
  const time = intl.formatTime(date, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
  if (isSameDay(date, now)) return time;
  const day = intl.formatDate(date, {
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: "2-digit" }),
    month: "2-digit",
    day: "2-digit",
  });
  return `${day} ${time}`;
}

export function formatDateTime(intl: IntlShape, iso: string | null | undefined) {
  if (!iso) return "";
  const date = new Date(iso);
  return `${intl.formatDate(date, { year: "numeric", month: "2-digit", day: "2-digit" })} ${intl.formatTime(date, { hour: "2-digit", minute: "2-digit", hourCycle: "h23" })}`;
}

// Elapsed time in the largest whole unit, e.g. "5 minutes ago".
export function formatAgo(intl: IntlShape, iso: string | null | undefined, now = Date.now()) {
  if (!iso) return "";
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 60) return intl.formatRelativeTime(seconds, "second", { numeric: "auto" });
  if (abs < 3600) return intl.formatRelativeTime(Math.round(seconds / 60), "minute");
  if (abs < 86400) return intl.formatRelativeTime(Math.round(seconds / 3600), "hour");
  return intl.formatRelativeTime(Math.round(seconds / 86400), "day");
}

export function isTemporarilyInactive(tempInactiveTs: string | null | undefined, now = Date.now()) {
  return !!tempInactiveTs && new Date(tempInactiveTs).getTime() > now;
}
